import React, {Component} from "react";
import {Button} from "antd";
import * as PropTypes from "prop-types";

export class ResetPasswordButton extends Component {
  state = {
    sending: false
  };

  handleClick = event => {
    this.setState({ sending: true });
    this.props.onClick && this.props.onClick(event);
  };

  render() {
    return <Button type='primary' className='full-width' loading={this.state.sending} onClick={this.handleClick}>Reset
      Password</Button>;
  }
}

ResetPasswordButton.propTypes = { onClick: PropTypes.any };


// WEBPACK FOOTER //
// ./src/components/Security/Boilerplate/ResetPasswordButton.js